/**
 * Module dependencies.
 */

import { MenuItem } from 'app/types/navigation';

/**
 * Export `compileMenu`.
 *
 * Normalizes a menu tree. Navigation is handled by the shell that renders the
 * items (each row is already a link), so labels are kept as plain content —
 * wrapping them in an anchor here would nest `<a>` inside `<a>`.
 */

export function compileMenu(menu: MenuItem[]): MenuItem[] {
  return menu.map((item: MenuItem) => ({
    ...item,
    children: item.children ? compileMenu(item.children) : undefined
  }));
}
